// extracted by mini-css-extract-plugin
module.exports = {"Form":"Introduction_Form__2EF7R"};